// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--KWHoG","tab":"_9e1425b4d3--tab--isIny","_active":"_9e1425b4d3--_active--CVqT0","_disabled":"_9e1425b4d3--_disabled--Ru9EO"};